<template>
  <div class="flex flex-col max-w-6xl mx-auto px-6 py-8">
    <div v-if="assessmentResults.length != 0">
      <h1
        class="text-xl text-left text-gray-700 font-medium"
      >แผนภูมิการเปรียบเทียบค่าเฉลี่ยและส่วนเบี่ยงเบนมาตรฐาน</h1>
      <p class="text-left mb-2">จากการทำแบบทดสอบ {{assessmentResults.length}} ครั้ง</p>

      <x-bar-sd-chart
        class="w-full h-96 mx-auto mb-8"
        :labels="resultTimeSeries.labels"
        :averages="resultTimeSeries.averages"
        :sds="resultTimeSeries.standardDeviations"
        :average="facultyAverage"
        :universityAverage="universityAverage"
        :yMax="25"
      />
    </div>

    <div class="flex mx-auto mb-8">
      <div class="flex items-center">
        <div class="w-12 h-1" style="background-color:#9E76B4"></div>

        <p class="text-xs ml-2">ค่าเฉลี่ยมหาวิทยาลัย</p>
      </div>

      <div class="flex items-center ml-8">
        <div class="w-12 h-1" style="background-color:#93D124"></div>

        <p class="text-xs ml-2">ค่าเฉลี่ยของบุคลากรภายในคณะเดียวกัน</p>
      </div>
    </div>

    <h1 class="text-left text-xl text-gray-700 font-medium">รายการคัดกรองคุณภาพชีวิต</h1>
    <p class="block md:hidden">สามารถปัดหน้าจอไปทางด้านซ้ายเพื่อดูข้อมูลเพิ่มเติม</p>

    <div class="mt-4 -my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
      <div class="align-middle min-w-ful shadow-md border border-gray-200">
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >ครั้งที่</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >วันที่</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >ผลการคัดกรอง</th>

              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >คะแนน</th>

              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >ค่าเฉลี่ย</th>

              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >ส่วนเบี่ยงเบนมาตรฐาน</th>

              <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(result,index) in assessmentResults"
              :key="result.key"
              class="bg-white cursor-pointer"
              @click="$router.push({path: `/assessment-whoqol/${result.id}`})"
            >
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >{{assessmentResults.length - index}}</td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
              >{{result.formatted_created_at}}</td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
              >{{result.final_result}}</td>

              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
              >{{JSON.parse(result.raw_final_result).result.point}} คะแนน</td>

              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
              >{{result.average}}</td>

              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
              >{{result.standard_deviation}}</td>

              <td class="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5 font-medium">
                <router-link
                  :to="{name: 'assessment-whoqol.result',params: {id: result.id}}"
                  class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                >ดูรายละเอียด</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AverageSdStackedBarChart from "../components/charts/AverageSdStackedBarChart";
import { Tabs, Tab } from "vue-slim-tabs";
import axios from "axios";

export default {
  name: "hplp-dashboard",
  components: {
    "x-bar-sd-chart": AverageSdStackedBarChart,
    Tabs,
    Tab
  },
  async created() {
    let loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer
    });

    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/whoqol-assessment`,
        headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
      });

      this.assessmentResults = response.data.assessments;
      this.facultyAverage = response.data.faculty_average;
      this.universityAverage = response.data.university_average;
      loader.hide();
    } catch (error) {
      console.log(error);

      loader.hide();
    }
  },
  data() {
    return {
      assessmentResults: [],
      facultyAverage: 0,
      universityAverage: 0
    };
  },
  computed: {
    resultTimeSeries() {
      const averages = this.assessmentResults.map(result =>
        parseFloat(result.average)
      );
      const standardDeviations = this.assessmentResults.map(result =>
        parseFloat(result.standard_deviation)
      );

      const labels = this.assessmentResults.map(
        (result, time) => `ครั้งที่ ${this.assessmentResults.length - time}`
      );

      return { averages, standardDeviations, labels };
    }
  }
};
</script>

<style src="vue-slim-tabs/themes/default.css"></style>
